<template>
  <div class="fd-portal">
    <el-row>
      <el-col :span="12" style="box-sizing:border-box;padding-left:15px;padding-right:8px;">
        <el-carousel trigger="click" :loop="true" :interval="5000" arrow="never" height="324px">
          <el-carousel-item v-for="(item, index) of headLine" :key="index">
            <img :src="item.src" style="height:100%;width:100%;object-fit: cover" :title="item.title" @click="toDetial(item)" alt="" />
            <div
              style="background:rgba(0,0,0,.7);height:30px;line-height:30px;position:absolute;bottom:0;width:100%;text-align:left"
              @click="toDetial(item.id)">
              <span
                style="display:inline-block;width:80%;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;text-indent:1em;color:#fff;text-align:left"
                :title="item.title">{{ item.title }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </el-col>
      <el-col :span="12">
        <news :newsName="tzyw" :title="title2" :columnCode="columnCode2" :menuList="menus.xwzxMenuList"
          :tableData="SYZT_XWZX_TZYW" :path="tzywPath"></news>
      </el-col>
    </el-row>
    <el-row style="margin-top:16px">
      <el-col :span="9">
        <news :newsName="syxw" :title="title1" :newsContent="newsContent" :columnCode="columnCode1"
          :menuList="menus.xwzxMenuList" :tableData="SYZT_XWZX_SYXW" :path="syxwPath"></news>
      </el-col>
      <el-col :span="9">
        <news :newsName="tzgg" :title="title9" :columnCode="columnCode9" :menuList="menus.xwzxMenuList"
          :tableData="SYZT_XWZX_TZGG" :path="tzggPath"></news>
        <news :newsName="sxsy" :title="title3" :columnCode="columnCode3" :menuList="menus.xwzxMenuList"
          :tableData="SYZT_XWZX_SXXW" :path="sxxwPath"></news>
      </el-col>
      <el-col :span="6">
        <div v-for="(item, index) of 4" :key="index" :class="'FirstimgList' + index" @click="zjyClick(index)"
          style="margin:8px 8px;border-radius:5px">
          </div>
      </el-col>
    </el-row>
    <!-- <el-row>
                 <el-col :span="6" v-for="(item,index) of 4" :key="index" :class="'SecondimgList'+index" style="margin:10px 0;border-radius:5px">
                 </el-col>
             </el-row> -->
    <el-row style="margin-top:20px;display:flex;justify-content:space-between">
      <div v-for="item of yjzxList" :key="item" @click="getCenter(item)" style="width:24%;height:123px;cursor:pointer"
        :class="item"></div>
    </el-row>

    <!-- <el-row style="margin-top:20px" :class="SYZT_ZT ?'fd-zt button-show' :'fd-zt button-hidden'">
        <swiper ref="mySwiper" :options="swiperOptions" >
              <swiper-slide v-for="(item,index) of SYZT_ZT" :key="index" >
                  <div :class="'BianzuimgList'+index" :style="{margin:'10px 0',borderRadius:'5px',cursor:'pointer',backgroundImage:'url(' + item.src + ')'}"  @click="ztClick(item)">
                  </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
      </el-row> -->

    <el-row style="margin-top:30px">
      <el-col :span="12">
        <news :newsName="jxpx" :newsContent="newsContent" :title="title4" :menuList="menus.jxpxMenuList"
          :columnCode="columnCode4" :tableData="SYZT_JXPX_JXXX" :path="jxxxPath"></news>
      </el-col>
      <!--教学培训-->
      <el-col :span="12">
        <news :newsName="whjl" :newsContent="newsContent" :title="title5" :menuList="menus.whjlMenuList"
          :columnCode="columnCode5" :tableData="SYZT_WHJL" :path="zhwhPath"></news>
      </el-col>
      <!--文化交流-->
    </el-row>

    <el-row style="margin-top:30px">
      <el-col :span="12">
        <news :newsName="kyzk" :title="title6" :menuList="menus.kyzkMenuList" :columnCode="columnCode6"
          :tableData="SYZT_KYZK" :path="kycgPath"></news>
      </el-col>
      <el-col :span="12">
        <news :newsName="tzll" :title="title7" :menuList="menus.yjdtMenuList" :columnCode="columnCode7"
          :tableData="SYZT_YJDT" :path="tzwxPath"></news>
      </el-col>
      <!-- <el-col :span="8" >
          <news
            :title="title8"
            :menuList="zTmenuList"
            :columnCode="columnCode8"
            :tableData="ZT_NEWS"
            :path="ztPath"
          ></news>
        </el-col> -->
    </el-row>
    <!-- <el-row style="margin:20px 0;" :class="SYZT_ZT ?'fd-zt button-show' :'fd-zt button-hidden'">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(item,index) of SYZT_ZT" :key="index">
          <div :class="'BianzuimgList'+index%4"
            :style="item.attachmentId ? {margin:'10px 5px',borderRadius:'5px',cursor:'pointer', backgroundImage:'url(' + item.src + ')'} : {margin:'10px 5px',borderRadius:'5px',cursor:'pointer'}"
            @click="ztClick(item)">
            <div v-if="!item.attachmentId">{{item.columnName}}</div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev" v-if="SYZT_ZT.length>4" @click="swiper.slidePrev()"></div>
      <div class="swiper-button-next" v-if="SYZT_ZT.length>4" @click="swiper.slideNext()"></div>
    </el-row> -->
    <el-row style="margin:20px 0 0 0">
      <div class="fd-xglj">
        <div style="position:relative; margin:0 8px" class="news-title">
          <span class="fd-reset">
            <img src="../assets/images/newsTitle.png" alt="" style="position:absolute;" /> 社院导航
          </span>
        </div>
        <ul>
          <li>
            <el-link href="https://www.zysy.org.cn/" target="_blank">中央社院</el-link>
          </li>
          <li>
            <el-link href="http://bjsy.org.cn/" target="_blank">北京社院</el-link>
          </li>
          <li>
            <el-link href="http://www.tjsy.org.cn/" target="_blank">天津社院</el-link>
          </li>
          <li>
            <el-link href="http://www.hebeisy.org.cn/" target="_blank">河北社院</el-link>
          </li>
          <li>
            <el-link href="https://www.shxsy.org.cn/" target="_blank">山西社院</el-link>
          </li>
          <li>
            <el-link href="http://www.nmgsy.com.cn/" target="_blank">内蒙古社院</el-link>
          </li>
          <li>
            <el-link href="http://www.lnswdx.cn/" target="_blank">辽宁社院</el-link>
          </li>
          <li>
            <el-link href="http://www.jlsy.org.cn/" target="_blank">吉林社院</el-link>
          </li>
          <li>
            <el-link href="http://www.hljsshzyxy.org.cn/" target="_blank">黑龙江社院</el-link>
          </li>
          <li>
            <el-link href="http://www.shsy.org.cn/" target="_blank">上海社院</el-link>
          </li>
          <li>
            <el-link href="http://www.jssy.org.cn/" target="_blank">江苏社院</el-link>
          </li>
          <!-- <li>
            <el-link href="http://www.zjsy.org.cn/#/portal"
                     target="_blank">浙江社院</el-link>
          </li> -->
          <li>
            <el-link href="http://www.ahsy.org.cn/" target="_blank">安徽社院</el-link>
          </li>
          <li>
            <el-link href="http://www.fjssy.org.cn/" target="_blank">福建社院</el-link>
          </li>
          <li>
            <el-link href="http://www.jxsy.org.cn/" target="_blank">江西社院</el-link>
          </li>
          <li>
            <el-link href="http://www.sdsy.org.cn/" target="_blank">山东社院</el-link>
          </li>
          <li>
            <el-link href="http://www.hnssy.org.cn/" target="_blank">河南社院</el-link>
          </li>
          <li>
            <el-link href="http://www.hbsy.org.cn/" target="_blank">湖北社院</el-link>
          </li>
          <li>
            <el-link href="http://www.hnsy.org.cn/" target="_blank">湖南社院</el-link>
          </li>
          <li>
            <el-link href="http://www.gdsy.com.cn/gdsy/Index.shtml" target="_blank">广东社院</el-link>
          </li>

          <li>
            <el-link href="http://www.gxsy.org/" target="_blank">广西社院</el-link>
          </li>
          <li>
            <el-link href="http://www.dx.hainan.gov.cn/" target="_blank">海南社院</el-link>
          </li>
          <li>
            <el-link href="https://www.cqsy.net.cn/" target="_blank">重庆社院</el-link>
          </li>
          <li>
            <el-link href="http://www.scsy.org.cn/" target="_blank">四川社院</el-link>
          </li>
          <li>
            <el-link href="http://www.gzssy.org.cn/" target="_blank">贵州社院</el-link>
          </li>
          <li>
            <el-link href="http://www.ynsy.org.cn/" target="_blank">云南社院</el-link>
          </li>
          <li>
            <el-link href="http://xz.zysy.cn/" target="_blank">西藏社院</el-link>
          </li>
          <li>
            <el-link href="http://www.shxsy.com.cn/" target="_blank">陕西社院</el-link>
          </li>
          <li>
            <el-link href="http://www.gsshy.org/" target="_blank">甘肃社院</el-link>
          </li>
          <li>
            <el-link href="http://www.qhswdx.com/" target="_blank">青海社院</el-link>
          </li>
          <li>
            <el-link href="https://www.nxsy.org.cn/" target="_blank">宁夏社院</el-link>
          </li>
          <li>
            <el-link href="http://www.xjsy.org/" target="_blank">新疆社院</el-link>
          </li>
          <li>
            <el-link></el-link>
          </li>
          <!-- <li>
            <el-link href="http://www.gzsy.org.cn/" target="_blank">广州社院</el-link>
          </li>
          <li>
            <el-link href="http://www.whsy.org/"
                     target="_blank">武汉社院</el-link>
          </li>
          <li>
            <el-link href="http://www.hrbsy.org.cn/index.html"
                     target="_blank">哈尔滨社院</el-link>
          </li>
          <li>
            <el-link href="http://www.zgsyswdx.com/"
                     target="_blank">沈阳社院</el-link>
          </li>
          <li>
            <el-link href="https://www.cddx.gov.cn/"
                     target="_blank">成都社院</el-link>
          </li>
          <li>
            <el-link href="http://sy.nanjing.gov.cn/"
                     target="_blank">南京社院</el-link>
          </li>
          <li>
            <el-link href="http://www.xaswdx.com/"
                     target="_blank">西安社院</el-link>
          </li>
          <li>
            <el-link href="1"
                     target="_blank">长春社院</el-link>
          </li>
          <li>
            <el-link href="http://jndx.gov.cn/"
                     target="_blank">济南社院</el-link>
          </li>
          <li>
            <el-link href="1"
                     target="_blank">杭州社院</el-link>
          </li>
          <li>
            <el-link href="http://www.swdx.dl.gov.cn/portal/index!index.action"
                     target="_blank">大连社院</el-link>
          </li>
          <li>
            <el-link href="http://qdsy.qingdao.cn/n28356042/index.html"
                     target="_blank">青岛社院</el-link>
          </li>
          <li>
            <el-link href="http://www.szps.gov.cn/shenzhen/"
                     target="_blank">深圳社院</el-link>
          </li>
          <li>
            <el-link href="http://www.xmdx.gov.cn/"
                     target="_blank">厦门社院</el-link>
          </li>
          <li>
            <el-link href="https://www.nbdx.cn/"
                     target="_blank">宁波社院</el-link>
          </li>
          <li>
            <el-link href="http://dwdx.xjbt.gov.cn/"
                     target="_blank">新疆建设兵团社院</el-link>
          </li> -->
        </ul>
      </div>
    </el-row>

    <el-row style="margin:20px 0 ">
      <div class="fd-xglj">
        <div style="position:relative; margin:0 8px" class="news-title">
          <span class="fd-reset">
            <img src="../assets/images/newsTitle.png" alt="" style="position:absolute;" /> 相关链接
          </span>
        </div>
        <ul>
          <li>
            <el-link href="http://www.cppcc.gov.cn/" target="_blank">全国政协</el-link>
          </li>
          <li>
            <el-link href="http://www.zytzb.gov.cn/html/index.html" target="_blank">中央统战部</el-link>
          </li>
          <li>
            <el-link href="http://www.minge.gov.cn/" target="_blank">中国国民党革命委员会</el-link>
          </li>
          <li>
            <el-link href="http://www.dem-league.org.cn/" target="_blank">中国民主同盟</el-link>
          </li>
          <li>
            <el-link href="https://www.cndca.org.cn/" target="_blank">中国民主建国会</el-link>
          </li>
          <li>
            <el-link href="https://www.mj.org.cn/" target="_blank">中国民主促进会</el-link>
          </li>
          <li>
            <el-link href="http://www.ngd.org.cn/" target="_blank">中国农工民主党</el-link>
          </li>
          <li>
            <el-link href="http://www.zg.org.cn/" target="_blank">中国致公党</el-link>
          </li>
          <li>
            <el-link href="http://www.93.gov.cn/" target="_blank">九三学社</el-link>
          </li>
          <li>
            <el-link href="https://www.taimeng.org.cn/" target="_blank">台湾民主自治同盟</el-link>
          </li>
          <li>
            <el-link href="https://www.neac.gov.cn/" target="_blank">国家民委</el-link>
          </li>
          <li>
            <el-link href="http://www.gwytb.gov.cn/" target="_blank">国务院台办</el-link>
          </li>
          <li>
            <el-link href="http://www.acfic.org.cn/" target="_blank">全国工商联</el-link>
          </li>
          <li>
            <el-link href="http://www.tailian.org.cn/" target="_blank">全国台联</el-link>
          </li>
          <li>
            <el-link href="http://www.taiwan.cn/" target="_blank">中国台湾网</el-link>
          </li>
          <li>
            <el-link href="http://www.chinaql.org/" target="_blank">中国侨联</el-link>
          </li>
          <li>
            <el-link href="http://www.zjzx.gov.cn/" target="_blank">浙江省政协</el-link>
          </li>
          <li>
            <el-link href="http://www.qxzh.zj.cn/" target="_blank">浙江省委统战部</el-link>
          </li>
          <li>
            <el-link href="http://www.zjmg.gov.cn/" target="_blank">民革浙江省委会</el-link>
          </li>
          <li>
            <el-link href="http://www.zjmm.org.cn/" target="_blank">民盟浙江省委会</el-link>
          </li>
          <li>
            <el-link href="http://www.zjmj.cn/" target="_blank">民建浙江省委会</el-link>
          </li>
          <li>
            <el-link href="http://www.zjmj.org/" target="_blank">民进浙江省委会</el-link>
          </li>
          <li>
            <el-link href="http://www.zjngd.org.cn/" target="_blank">农工党浙江省委会</el-link>
          </li>
          <li>
            <el-link href="http://www.zjzg.org.cn/" target="_blank">致公党浙江省委会</el-link>
          </li>
          <li>
            <el-link href="http://www.zjjs.org/" target="_blank">九三学社浙江省委会</el-link>
          </li>
          <!-- <li>
            <el-link href="https://www.hao123.com/"
                     target="_blank">网址大全</el-link>
          </li> -->
          <li>
            <el-link href="http://www.lybs.com.cn/" target="_blank">联谊报</el-link>
          </li>
          <li>
            <el-link href="http://hqhr.jnu.edu.cn/" target="_blank">华人华侨</el-link>
          </li>
          <li>
            <el-link href="http://www.tuanjiebao.com/" target="_blank">团结报</el-link>
          </li>
          <li>
            <el-link href="http://dzb.rmzxb.com/" target="_blank">人民政协报</el-link>
          </li>
        </ul>
      </div>
    </el-row>
    <div style="position:fixed;bottom:0;right:40px;width:8vw;z-index:1000" class="fd-float-box" v-if="isClose">
      <!-- <div style="width:100%;line-height:30px;text-align:center;border:4px solid #EDEDED;margin-bottom:10px;color:#1A73E7;cursor: pointer;background:#fff" @click="selectGg">
        公告
      </div> -->
      <!-- <div style="width:100%;height:8vw;line-height:30px;text-align:center;border:6px solid #EDEDED;color:#1A73E7;margin-bottom: 10px;"
        class="fd-ewm-three"></div> -->
      <div
        style="width:100%;line-height:30px;text-align:center;border:6px solid #EDEDED;margin-bottom:10px;color:#1A73E7;cursor: pointer;background:#fff"
        @click="gotoDetails">
        纪检组监督举报<br />联系方式
      </div>
      <div style="width:100%;height:8vw;line-height:30px;text-align:center;border:6px solid #EDEDED;color:#1A73E7"
        class="fd-ewm-one"></div>
      <div style="width:100%;background:#EDEDED;padding:0 6px;margin-bottom:10px;height:30px;line-height:30px;">
        浙江社院公众号
      </div>
      <div style="width:100%;height:8vw;line-height:30px;text-align:center;border:6px solid #EDEDED;color:#1A73E7"
        class="fd-ewm-two"></div>
      <div style="width:100%;background:#EDEDED;padding:0 6px;margin-bottom:10px;height:30px;line-height:30px;">
        手机版网站
      </div>
      <div
        style="width:100%;line-height:30px;text-align:center;border:6px solid #EDEDED;margin-bottom:10px;color:#1A73E7;cursor: pointer;background:#fff"
        @click="selectYjs">
        预决算信息
      </div>
       <div  style="width:100%;line-height:30px;text-align:center;border:6px solid #EDEDED;margin-bottom:10px;color:#1A73E7;cursor: pointer;background:#fff" class="fd-close-btn" @click="handleCloseFixed">关闭</div>
    </div>

    <div id="pftp" style="position:absolute;z-index:1001;" @mouseenter="mouseOver()" @mouseleave="mouseOut()">
      <span style="position: absolute;right: -10px;font-size: 20px;cursor: pointer" @click="closePftp()">x</span>
      <a style="display: block"><br></a>
      <a :href="SYZT_PFTP.content" target="_blank">
        <img :src="SYZT_PFTP.src" :width="SYZT_PFTP.imageWidth" :height="SYZT_PFTP.imageHeight">
      </a>
    </div>
  </div>
</template>
<script>
import news from '../components/news.vue';
export default {
  components: {
    news
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    this.x = window.innerWidth / 2;
    this.y = window.innerHeight / 2;
  },
  mounted() {
    this.loadAllDatas();
    this.getHeadLine();
    this.getSyxw();
    this.getTzyw();
    this.getGsgg();
    this.getSxxw();
    this.getJxxx();
    this.getWhjl();
    this.getKyzk();
    this.getTzll();
    this.getPftp();
  },
  data() {
    return {
      newsContent: [
        {
          title: '浙江社院成功举办第三届省职教社社员代表培训班',
          content:
            '7月5日至9日，第三届省职教社社员代表培训班在浙江省社会主义学院成功举办，省委统战部副部长、省职教社常务副主任王利月分别出席开班式和结业式并讲话，浙江省社会主义学院党组成员、副院长闵涛出席开班式并致辞。来自全省的近50名社员代表参加本次培训。（教学培训内容）',
          imgSrcJxxx: ''
        },
        {
          title:
            '浙江中华文化学院推出“空中大课堂”2021年第6期“忠实践行‘八八战略’，奋力打造‘重要窗口’”',
          content:
            '由浙江中华文化学院中华文化网络学院主办、浙江中华文化海外传播促进会协办、哈兔中文网络学院承办的2021年第6期“空中大课堂”于北京时间7月23日20时30分开播，讲座时间1小时。来自西班牙、意大利、法国、匈牙利、捷克、印度尼西亚、韩国、马来西亚、印度、泰国、巴基斯坦等分布在各大洲41个国家和地区的26300余户家庭在线收看了本期讲座。',
          imgSrcWhjl: ''
        },
        {
          title: '',
          content: '',
          imgSrcSyxw: ''
        }
      ],
      yjzxList: [
        'SYZT_CZDJSYJZX',
        'SYZT_FGJJLGJKYJZX',
        'SYZT_MZYZJYJZX',
        'SYZT_ZHWHYJZX'
      ],
      title1: '本院新闻',
      title2: '新闻时讯',
      title3: '市县社院',
      title4: '教学培训',
      title5: '文化交流',
      title6: '科研智库',
      title7: '研究动态',
      title8: '专题资料',
      title9: '公示公告',
      columnCode1: 'SYZT_XWZX_SYXW',
      columnCode2: 'SYZT_XWZX_TZYW',
      columnCode3: 'SYZT_XWZX_SXXW',
      columnCode4: 'SYZT_JXPX_JXXX',
      columnCode5: 'SYZT_WHJL_ZHWH',
      columnCode6: 'SYZT_KYZK_KYCG',
      // columnCode7: 'SYZT_TZLL_TZWX',
      columnCode7: 'SYZT_CZDJSYJZX_ZXGK',
      columnCode8: 'SYZT_ZT01',
      columnCode9: 'SYZT_XWZX_TZGG',
      syxwPath: '/xwzx/syxw',
      tzywPath: '/xwzx/tzyw',
      sxxwPath: '/xwzx/sxxw',
      jxxxPath: '/jxpx/jxxx',
      zhwhPath: '/whjl/zhwh',
      kycgPath: '/kyzk/kycg',
      // tzwxPath: '/tzll/tzwx',
      tzwxPath: '/yjdt/czdjsyjzx/zxgk',
      ztPath: '/zt/zt01',
      tzggPath: '/xwzx/tzgg',
      tzyw: 'tzyw',
      syxw: 'syxw',
      sxsy: 'sxsy',
      jxpx: 'jxpx',
      whjl: 'whjl',
      kyzk: 'kyzk',
      tzll: 'tzll',
      tzgg: 'tzgg',
      path: '',
      columnCode: '',
      // 头条图片新闻
      headLine: [],
      // 社院新闻
      SYZT_XWZX_SYXW: [],
      // 统战要闻
      SYZT_XWZX_TZYW: [],
      // 市县新闻
      SYZT_XWZX_SXXW: [],
      // 教学信息
      SYZT_JXPX_JXXX: [],
      // 文化交流
      SYZT_WHJL: [],
      // 科研智库
      SYZT_KYZK: [],
      // 统战理论
      SYZT_YJDT: [],
      // 专题资料（滚动栏）
      SYZT_ZT: [],
      // 专题治疗新闻（新闻列表）
      ZT_NEWS: [],
      // 漂浮图片
      SYZT_PFTP: {},
      //浮动广告的初始位置
      x: 0,
      y: 0,
      //xin为真则向右运动，否则向左运动
      xin: false,
      //yin为真则向下运动，否则向上运动
      yin: false,
      //移动的距离
      step: 1,
      //移动的时间间隔
      delay: 30,
      pftpInterval: '',
      zTmenuList: {},
      swiperOptions: {
        // autoplay: true,
        speed: 100,
        slidesPerView: 4, // 显示个数
        slidesGroup: 1, // 显示个数
        loop: false,
        direction: 'horizontal'
      },
      menuList: [],
      isClose:true
    };
  },

  methods: {
    handleCloseFixed() {
      this.isClose = false;
    },
    ztClick(item) {
      if (this.zTmenuList[item.id].length > 0) {
        localStorage.setItem(
          'menuList',
          JSON.stringify(this.zTmenuList[item.id])
        );
        const self = this;
        self.$router.push({
          path: `/zt/${this.zTmenuList[item.id][0].menuCode}`,
          query: {
            // menuList: JSON.stringify(self.zTmenuList[item.id]),
            columnCode: this.zTmenuList[item.id][0].menuCode
          }
        });
      } else {
        sessionStorage.setItem('menuList', JSON.stringify([]));
        this.$router.push({
          path: '/zt',
          query: {
            // menuList: JSON.stringify(self.zTmenuList[item.id]),
            // columnCode: this.zTmenuList[item.id][0].menuCode,
          }
        });
      }

      // if (index === 0) {
      //   (this.path = "/zt/zt01"), (this.columnCode = "SYZT_ZT01");
      // } else if (index === 1) {
      //   (this.path = "/zt/zt02"), (this.columnCode = "SYZT_ZT02");
      // } else if (index === 2) {
      //   (this.path = "/zt/zt03"), (this.columnCode = "SYZT_ZT03");
      // } else if (index === 3) {
      //   (this.path = "/zt/zt04"), (this.columnCode = "SYZT_ZT04");
      // }
      // this.$router.push({
      //   path: this.path,
      //   query: {
      //     columnCode: this.columnCode,
      //     menuList: JSON.stringify(this.menus.ztMenuList)
      //   }
      // });
    },
    zjyClick(index) {
      if (index === 0) {
        window.open(
          'https://zsy.zjsy.org.cn'

        );
      } else if (index === 1) {
        window.open('https://www.zjsywlxx.org.cn');
      } else if (index === 2) {
        window.open('http://tyzx.zjsywlxx.org.cn');
      } else if (index === 3) {
        window.open('https://zk.zjsy.org.cn/syzk/login');
      }
    },
    getCenter(item) {
      // localStorage.setItem(
      //     'menuList',
      //     JSON.stringify(this.menus.yjdtMenuList),
      //   );
      // if (item === 'SYZT_CZDJSYJZX') {
      //   // this.menuList = this.menus.czdzxMenuList;
      //   this.path = '/yjdt/czdjsyjzx/zxgk';
      //   this.columnCode = 'SYZT_CZDJSYJZX_ZXGK';
      // } else if (item === 'SYZT_FGJJLGJKYJZX') {
      //   // this.menuList = this.menus.fgyzjjzxMenuList;
      //   this.path = '/yjdt/fgyzjjzx/zxgk';
      //   this.columnCode = 'SYZT_FGYZJJZX_ZXGK';
      // } else if (item === 'SYZT_MZYZJYJZX') {
      //   // this.menuList = this.menus.mzyzjzxMenuList;
      //   this.path = '/yjdt/mzyzjzx/zxgk';
      //   this.columnCode = 'SYZT_MZYZJYJZX_ZXGK';
      // } else if (item === 'SYZT_ZHWHYJZX') {
      //   // this.menuList = this.menus.zhwhzxMenuList;
      //   this.path = '/yjdt/zhwhzx/zxgk';
      //   this.columnCode = 'SYZT_ZHWHYJZX_ZXGK';
      // }
      // this.$router.push({
      //   path: this.path,
      //   query: {
      //     // menuList: JSON.stringify(this.menuList),
      //     columnCode: this.columnCode,
      //   },
      // });

      if (item === 'SYZT_CZDJSYJZX') {
        localStorage.setItem(
          'menuList',
          JSON.stringify(this.menus.czdzxMenuList)
        );
        // this.menuList = this.menus.czdzxMenuList;
        this.path = '/czdzx/zxgk';
        this.columnCode = 'SYZT_CZDJSYJZX_ZXGK';
      } else if (item === 'SYZT_FGJJLGJKYJZX') {
        localStorage.setItem(
          'menuList',
          JSON.stringify(this.menus.fgyzjjzxMenuList)
        );
        // this.menuList = this.menus.fgyzjjzxMenuList;
        this.path = '/fgyzjjzx/zxgk';
        this.columnCode = 'SYZT_FGYZJJZX_ZXGK';
      } else if (item === 'SYZT_MZYZJYJZX') {
        localStorage.setItem(
          'menuList',
          JSON.stringify(this.menus.mzyzjzxMenuList)
        );
        // this.menuList = this.menus.mzyzjzxMenuList;
        this.path = '/mzyzjzx/zxgk';
        this.columnCode = 'SYZT_MZYZJYJZX_ZXGK';
      } else if (item === 'SYZT_ZHWHYJZX') {
        localStorage.setItem(
          'menuList',
          JSON.stringify(this.menus.zhwhzxMenuList)
        );
        // this.menuList = this.menus.zhwhzxMenuList;
        this.path = '/zhwhzx/zxgk';
        this.columnCode = 'SYZT_ZHWHYJZX_ZXGK';
      }
      this.$router.push({
        path: this.path,
        query: {
          // menuList: JSON.stringify(this.menuList),
          columnCode: this.columnCode,
          path:this.path
        }
      });
      this.$router.go(0);
    },
    loadAllDatas() {
      const self = this;
      this.axios.get('api/vi/portal/frontPage/zt', {}, {}, (response) => {
        const res = response;
        if (res.data) {
          // 专题资料（滚动栏）
          if (res.data.SYZT_ZT) {
            if (res.data.SYZT_ZT && res.data.SYZT_ZT.length !== 0) {
              self.SYZT_ZT = res.data.SYZT_ZT;
              self.SYZT_ZT.forEach(function (value, i) {
                self.zTmenuList[value.id] = [];
                value.secondColumn.forEach((item) => {
                  self.zTmenuList[value.id].push({
                    menuCode: item.columnCode,
                    menuName: item.columnName,
                    menuUrl: `/zt/${item.columnCode}`
                  });
                });
                self.SYZT_ZT[i].src =
                  `${self.imgUrl.path
                  }?fid=${
                    value.attachmentId
                  }&chksum=${
                    value.checksum}`;
              });
            } else {
              self.SYZT_ZT = null;
            }
          }
          // 专题资料（新闻列表）
          self.ZT_NEWS = res.data.ZT_NEWS;
        }
      });
    },
    getHeadLine() {
      const self = this;
      this.axios.get(
        'api/vi/portal/frontPage/HeadlinePicture',
        {},
        {},
        (response) => {
          const res = response;
          if (res.data) {
            // 头条图片新闻
            // 图片待处理
            if (res.data.headLine) {
              self.headLine = res.data.headLine;
              res.data.headLine.forEach(function (value, i) {
                self.headLine[i].src =
                  `${self.imgUrl.path
                  }?fid=${
                    value.attachmentId
                  }&chksum=${
                    value.checksum}`;
              });
            }
          }
        }
      );
    },
    getSyxw() {
      const self = this;
      this.axios.get('api/vi/portal/frontPage/syxw', {}, {}, (response) => {
        const res = response;
        if (res.data) {
          if (res.data.SYZT_XWZX_SYXW[0].url) {
            this.newsContent[2] = res.data.SYZT_XWZX_SYXW[0];
            this.newsContent[2].title = res.data.SYZT_XWZX_SYXW[0].title;
            this.newsContent[2].imgSrcSyxw = res.data.SYZT_XWZX_SYXW[0].url;
            this.newsContent[2].content = res.data.SYZT_XWZX_SYXW[0].content;
            this.SYZT_XWZX_SYXW = res.data.SYZT_XWZX_SYXW.slice(
              1,
              self.SYZT_XWZX_SYXW.length - 2
            );
          } else {
            this.newsContent[2].title = res.data.SYZT_XWZX_SYXW[0].title;
            this.SYZT_XWZX_SYXW = res.data.SYZT_XWZX_SYXW;
          }
        }
      });
    },
    getTzyw() {
      const self = this;
      this.axios.get('api/vi/portal/frontPage/tzyw', {}, {}, (response) => {
        const res = response;
        if (res.data) {
          // 统战要闻
          self.SYZT_XWZX_TZYW = res.data.SYZT_XWZX_TZYW;
        }
      });
    },
    getGsgg() {
      const self = this;
      this.axios.get('api/vi/portal/frontPage/gsgg', {}, {}, (response) => {
        const res = response;
        if (res.data) {
          // 公示公告
          self.SYZT_XWZX_TZGG = res.data.SYZT_XWZX_TZGG;
        }
      });
    },
    getSxxw() {
      const self = this;
      this.axios.get('api/vi/portal/frontPage/sxxw', {}, {}, (response) => {
        const res = response;
        if (res.data) {
          // 市县新闻
          self.SYZT_XWZX_SXXW = res.data.SYZT_XWZX_SXXW;
        }
      });
    },
    getJxxx() {
      const self = this;
      this.axios.get('api/vi/portal/frontPage/jxxx', {}, {}, (response) => {
        const res = response;
        if (res.data) {
          if (res.data.SYZT_JXPX_JXXX[0].url) {
            this.newsContent[0] = res.data.SYZT_JXPX_JXXX[0];
            this.newsContent[0].title = res.data.SYZT_JXPX_JXXX[0].title;
            this.newsContent[0].imgSrcJxxx = res.data.SYZT_JXPX_JXXX[0].url;
            this.newsContent[0].content = res.data.SYZT_JXPX_JXXX[0].content;
            this.SYZT_JXPX_JXXX = res.data.SYZT_JXPX_JXXX.slice(
              1,
              self.SYZT_JXPX_JXXX.length - 2
            );
          } else {
            this.SYZT_JXPX_JXXX = res.data.SYZT_JXPX_JXXX;
          }
        }
      });
    },
    getWhjl() {
      const self = this;
      this.axios.get('api/vi/portal/frontPage/whjl', {}, {}, (response) => {
        const res = response;
        if (res.data) {
          if (res.data.SYZT_WHJL[0].url) {
            this.newsContent[1] = res.data.SYZT_WHJL[0];
            this.newsContent[1].title = res.data.SYZT_WHJL[0].title;
            this.newsContent[1].imgSrcWhjl = res.data.SYZT_WHJL[0].url;
            this.newsContent[1].content = res.data.SYZT_WHJL[0].content;
            this.SYZT_WHJL = res.data.SYZT_WHJL.slice(
              1,
              self.SYZT_WHJL.length - 2
            );
          } else {
            this.SYZT_WHJL = res.data.SYZT_WHJL;
          }
        }
      });
    },
    getKyzk() {
      const self = this;
      this.axios.get('api/vi/portal/frontPage/kyzk', {}, {}, (response) => {
        const res = response;
        if (res.data) {
          // 科研智库
          self.SYZT_KYZK = res.data.SYZT_KYZK;
        }
      });
    },
    getTzll() {
      const self = this;
      this.axios.get('api/vi/portal/frontPage/tzll', {}, {}, (response) => {
        const res = response;
        if (res.data) {
          // 统战理论
          self.SYZT_YJDT = res.data.SYZT_YJDT;
        }
      });
    },
    getPftp() {
      const self = this;
      this.axios.get('api/vi/portal/frontPage/pftp', {}, {}, (response) => {
        const res = response;
        if (res.data.SYZT_PFTP) {
          self.SYZT_PFTP = res.data.SYZT_PFTP;
          self.SYZT_PFTP.src =
            `${self.imgUrl.path
            }?fid=${
              res.data.SYZT_PFTP.attachmentId
            }&chksum=${
              res.data.SYZT_PFTP.checksum}`;
          self.pftpInterval = setInterval(self.floatAD, self.delay);
        }
      });
    },
    floatAD() {
      const self = this;
      var L = 0, T = 0;//L为左边界T为上边界
      var R = window.innerWidth - document.getElementById("pftp").offsetWidth;
      //层移动到右边界
      var B = window.innerHeight - document.getElementById("pftp").offsetHeight;
      //层移动到下边界
      document.getElementById("pftp").style.left = self.x + "px";//层移动后的左边界
      document.getElementById("pftp").style.top = self.y + "px";//层移动后的上边界
      self.x = self.x + self.step * (self.xin ? 1 : -1);//判断水平方向
      if (self.x < L) {
        self.xin = true;
        self.x = L;
      }//层到达边界后的处理
      if (self.x > R) {
        self.xin = false;
        self.x = R;
      }
      self.y = self.y + self.step * (self.yin ? 1 : -1);
      if (self.y < T) {
        self.yin = true;
        self.y = T;
      }
      if (self.y > B) {
        self.yin = false;
        self.y = B;
      }
    },
    mouseOver() {
      const self = this;
      clearInterval(self.pftpInterval);
    },
    mouseOut() {
      const self = this;
      self.pftpInterval = setInterval(self.floatAD, self.delay);
    },
    closePftp() {
      const self = this;
      clearInterval(self.pftpInterval);
      document.getElementById("pftp").remove();
    },
    toDetial(item) {
      localStorage.setItem(
        'menuList',
        JSON.stringify(this.menus.xwzxMenuList)
      );
      let path = '';
      if (item.columnCode == 'SYZT_XWZX_SYXW') {
        path = '/xwzx/syxw';
      } else if (item.columnCode == 'SYZT_XWZX_TZYW') {
        path = '/xwzx/tzyw';
      }
      this.$router.push({
        path: '/wwnry',
        query: {
          id: item.id,
          columnCode: 'SYZT_XWZX_TZGG',
          path:path
        }
      });
    },
    // selectGg() {
    //   this.$router.push({
    //     path: "/xwzx/tzgg",
    //     query: {
    //       columnCode: "SYZT_XWZX_TZGG",
    //       menuList: JSON.stringify(this.menus.xwzxMenuList)
    //     }
    //   });
    // },
    selectYjs() {
      localStorage.setItem(
        'menuList',
        JSON.stringify(this.menus.yjsMenuList)
      );
      this.$router.push({
        path: '/yjs/yjsxx',
        query: {
          // menuList: JSON.stringify(this.menus.yjsMenuList),
          columnCode: 'yjsxxgk'
        }
      });
    },

    /**
     * 获取监督举报联系方式
     * @author  ： 吴俊迪 wujundi
     */
    gotoDetails() {
      localStorage.setItem('menuList', []);
      this.$router.push({
        path: '/wwnry',
        query: {
          columnCode: 'SYZT_ZL_JJZJDJBLXFS'
        }
      });
    }
  }
};
</script>
<style scoped>
.FirstimgList3 {
  height: 75px;
  background: url('../assets/images/qiepian00.png') no-repeat 100%;
  background-size: 100% 100%;
  cursor: pointer;
}

.FirstimgList2 {
  height: 75px;
  background: url('../assets/images/qiepian11.png') no-repeat 100%;
  background-size: 100% 100%;
  cursor: pointer;
}

.FirstimgList1 {
  height: 75px;
  background: url('../assets/images/qiepian22.png') no-repeat 100%;
  background-size: 100% 100%;
  cursor: pointer;
}

.FirstimgList0 {
  height: 75px;
  background: url('../assets/images/qiepian33.png') no-repeat 100%;
  background-size: 100% 100%;
  cursor: pointer;
}

.SecondimgList0 {
  height: 75px;
  background: url('../assets/images/qp0.png') no-repeat center;
  background-size: 100%;
  cursor: pointer;
}

.SecondimgList1 {
  height: 75px;
  background: url('../assets/images/qp1.png') no-repeat center;
  background-size: 100%;
  cursor: pointer;
}

.SecondimgList2 {
  height: 75px;
  background: url('../assets/images/qp2.png') no-repeat center;
  background-size: 100%;
  cursor: pointer;
}

.SecondimgList3 {
  height: 75px;
  background: url('../assets/images/qp3.png') no-repeat center;
  background-size: 100%;
  cursor: pointer;
}

.BianzuimgList0 {
  height: 124px;
  background: url('../assets/images/1.png') no-repeat center;
  cursor: pointer;
  line-height: 124px;
  background-size: 100%;
}
.BianzuimgList1 {
  height: 124px;
  background: url('../assets/images/2.png') no-repeat center;
  cursor: pointer;
  line-height: 124px;
  background-size: 100%;
}
.BianzuimgList2 {
  height: 124px;
  background: url('../assets/images/3.png') no-repeat center;
  cursor: pointer;
  line-height: 124px;
  background-size: 100%;
}
.BianzuimgList3 {
  height: 124px;
  background: url('../assets/images/4.png') no-repeat center;
  cursor: pointer;
  line-height: 124px;
  background-size: 100%;
}

.BianzuimgList0 div,.BianzuimgList1 div,.BianzuimgList2 div,.BianzuimgList3 div {
  width: 100%;
  /* margin-top: 40px !important; */
  font-size: 30px;
  color: #0174df;
  position: absolute;
}

/* .BianzuimgList1 {
  height: 124px;
  background: url('../assets/images/bianzu1.png') no-repeat center;
  cursor: pointer;
}

.BianzuimgList2 {
  height: 124px;
  background: url('../assets/images/bianzu2.png') no-repeat center;
  cursor: pointer;
}

.BianzuimgList3 {
  height: 124px;
  background: url('../assets/images/bianzu3.png') no-repeat center;
  cursor: pointer;
}

.BianzuimgList4 {
  height: 124px;
  background: url('../assets/images/bianzu3.png') no-repeat center;
  cursor: pointer;
} */

.BianzuimgList5 {
  height: 124px;
  background: url('../assets/images/bianzu3.png') no-repeat center;
  cursor: pointer;
}

.BianzuimgList6 {
  height: 124px;
  background: url('../assets/images/bianzu3.png') no-repeat center;
  cursor: pointer;
}

.BianzuimgList7 {
  height: 124px;
  background: url('../assets/images/bianzu3.png') no-repeat center;
  cursor: pointer;
}

.fd-sydh {
  width: 100%;
  height: 270px;
  margin-top: 10px;
  background: url('../assets/images/sydh.png') no-repeat center;
  background-size: 100%;
  overflow: hidden;
}

.fd-sydh ul {
  box-sizing: border-box;
  margin-left: 4vw;
  margin-top: 22px;
  height: 21px;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  flex-wrap: wrap;
}

.fd-sydh ul li {
  width: 12.5%;
  /*修改为一行八个*/
  margin: 9px auto;
  height: 42px;
}

.fd-sydh ul li a {
  font-size: 16px;
}

.fd-xglj {
  /* margin: 25px 0; */
}

.fd-xglj ul {
  display: flex;
  /* justify-content: space-around; */
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 15px;
}

.fd-xglj ul li {
  /* width: 16.6%; */
  margin: 4px 20px;
}

.fd-xglj ul li a {
  font-size: 14px;
}

.fd-portal-title {
  text-align: left;
}

.fd-ewm-one {
  background: url('../assets/qrCode/gzhQrCode.png');
  background-size: 100%;
}

.fd-ewm-three {
  background: url('../assets/qrCode/yyh.png');
  background-size: 100%;
}

.fd-ewm-two {
  background: url('../assets/qrCode/xmQRCode.png');
  background-size: 100%;
}

.czdj {
  background: url('../assets/images/czdj.png');
}

.fgyz {
  background: url('../assets/images/fgy.png');
}

.mzyzj {
  background: url('../assets/images/mz.png');
}

.zhwh {
  background: url('../assets/images/zhwh.png');
}
.news-title {
  height: 52px;
  /* background-image: linear-gradient(
    0deg,
    #def1ff 0%,
    rgba(231, 242, 255, 0) 100%
  ); */
  border-bottom: 1px solid #d2d2d2;
}
.fd-reset {
  position: relative;
  top: 16px;
}
.fd-reset img {
  left: 0 !important;
  top: 0px;
}
.SYZT_CZDJSYJZX {
  background: url('../assets/images/czdj.png');
  background-size: 100% 100%;
}

.SYZT_FGJJLGJKYJZX {
  background: url('../assets/images/fgy.png');
  background-size: 100% 100%;
}

.SYZT_MZYZJYJZX {
  background: url('../assets/images/mz.png');
  background-size: 100% 100%;
}

.SYZT_ZHWHYJZX {
  background: url('../assets/images/zhwh.png');
  background-size: 100% 100%;
}
</style>
<style>
.fd-portal .el-carousel__indicators--horizontal {
  display: inline-block;
  position: absolute;
  left: 92%;
  width: 70px;
}

.fd-portal .fd-zt .el-carousel__indicators--horizontal {
  display: none;
}

.fd-portal .fd-zt button {
  display: none;
}

.swiper-button-next.swiper-button-disabled,
.swiper-button-prev.swiper-button-disabled {
  pointer-events: visible;
}

.button-hidden .swiper-button-prev,
.button-hidden .swiper-button-next {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/page/portal.vue